/* @ngInject */
export default function (logService) {
  logService.startIntervalSendLogs();
}
